import LoginInfo from "../components/handlelogin/LoginInfo";

function Login() {
  return <LoginInfo></LoginInfo>;
}

export default Login;
